const BASE64_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

const decodeBase64 = (input: string): string => {
  const sanitized = input.replace(/[\r\n\s]/g, '').replace(/=+$/, '');

  if (!sanitized) {
    return '';
  }

  let bits = 0;
  let bitLength = 0;
  const bytes: number[] = [];

  for (let i = 0; i < sanitized.length; i++) {
    const index = BASE64_CHARS.indexOf(sanitized[i]);

    if (index < 0) {
      return '';
    }

    bits = (bits << 6) | index;
    bitLength += 6;

    if (bitLength >= 8) {
      bitLength -= 8;
      bytes.push((bits >> bitLength) & 0xff);
    }
  }

  try {
    return new TextDecoder().decode(new Uint8Array(bytes));
  } catch (error) {
    return '';
  }
};

const decodeSwapValue = (value: string): string => {
  if (!value) {
    return '';
  }

  try {
    return decodeBase64(value)
      .split('')
      .reverse()
      .join('');
  } catch (error) {
    return '';
  }
};

$(() => {
  $(document).on('click', '[data-swap-action]', function (event) {
    event.preventDefault();

    const $button = $(this);
    const action = String($button.data('swap-action') || '');
    const protocol = String($button.attr('data-swap-protocol') || '').trim();
    const encodedValue = String($button.attr('data-swap-value') || '').trim();
    const encodedLabel = String($button.attr('data-swap-label') || '').trim();
    const value = decodeSwapValue(encodedValue);
    const label = decodeSwapValue(encodedLabel) || value;

    if (!action || !protocol || !value) {
      return;
    }

    if (action === 'reveal-email' && !value.includes('@')) {
      return;
    }

    if (action === 'reveal-phone' && !/^[+0-9]+$/.test(value)) {
      return;
    }

    const $link = $('<a />', {
      class: 'btn btn--blue btn--medium',
      href: `${protocol}:${value}`,
      'aria-label': label,
      title: label,
    });
    const $icon = $button.find('i').first().clone();

    if ($icon.length) {
      $link.append($icon).append(document.createTextNode(` ${label}`));
    } else {
      $link.text(label);
    }

    const startWidth = $button.outerWidth() || 0;
    const $measure = $link
      .clone()
      .css({
        position: 'absolute',
        visibility: 'hidden',
        width: 'auto',
        minWidth: 0,
        maxWidth: 'none',
        left: -9999,
        top: -9999,
      })
      .appendTo(document.body);
    const targetWidth = Math.ceil($measure.outerWidth() || 0);
    $measure.remove();

    const finalWidth = Math.max(startWidth, targetWidth);

    $link
      .addClass('is-swap-link')
      .css({
        width: startWidth,
        minWidth: startWidth,
        opacity: 0,
      });

    $button.replaceWith($link);
    $link[0].offsetWidth;

    $link.css({
      width: finalWidth,
      minWidth: finalWidth,
      opacity: 1,
    });
  });
});
